import {Component, OnDestroy, OnInit} from '@angular/core';
import {UtilsService} from '../../../../core/utils/utils.service';
import {ActivatedRoute} from '@angular/router';
import {GenericFormService} from '../../../../core/services/generics/generic-form.service';
import {PointDeLivraisonService} from '../../../../core/services/entities/point-de-livraison.service';
import {GenericDatagridService} from "../../../../core/services/generics/generic-datagrid.service";
import {Subscription} from "rxjs";
import {PointDeLivraisonDTO} from "../../../../core/dtos/point-de-livraison-d-t-o";
import {ContratmenuDTO} from "../../../../core/dtos/contratmenu-dto";

@Component({
    selector: 'yo-point-de-livraison-prestation',
    templateUrl: './point-de-livraison-prestation.component.html',
    styleUrls: ['./point-de-livraison-prestation.component.scss'],
    standalone: false
})
export class PointDeLivraisonPrestationComponent implements OnInit, OnDestroy {

  subscriptionRoute: Subscription;
  pointDeLivraison: PointDeLivraisonDTO;
  prestations: ContratmenuDTO[];

  constructor(public utils: UtilsService,
              private route: ActivatedRoute,
              public gds: GenericDatagridService,
              public gfs: GenericFormService,
              public pdlSvc: PointDeLivraisonService) {
  }

  ngOnInit() {
    this.initRouteSubscription();
    this.initPrestations();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subscriptionRoute);
  }


  initRouteSubscription = (): void => {
    this.subscriptionRoute = this.route.parent.data
      .subscribe((data) => {
        this.pointDeLivraison = data.plcSupplier.pointDeLivraison;
      });
  };

  private initPrestations() {
    this.pdlSvc.getPrestations(this.pointDeLivraison.id).subscribe(response => {
      this.prestations = response.resultList;
    });

  }
}
